const OtherChannelOption = (id, label, channel_id, isSelected = true) => ({
  id,
  label,
  isSelected,
  channel_id,
});

export const OtherChannelOptions = [
  OtherChannelOption("SEM", "SEM", "GHA_SEM"),
  OtherChannelOption("pMax", "PMax for Travel Goals", "PMAX"),
  OtherChannelOption("displayAds", "Display Ads", "DISPLAY_ADS"),
  OtherChannelOption("aiConnect", "AI Connect", "AI_CONNECT"),
  OtherChannelOption("metaTravelAds", "Meta Hotel Ads", "META_TRAVEL_ADS")
];
